<script lang="ts">
    import {onMount} from "svelte";
    import {HttpRequestUtil} from "../../lib/Common/Http/HttpRequestUtil";
    import {AuthStore} from "../../store/AuthStore";
    import {UrlUtil} from "../../lib/Common/Http/UrlUtil";
    import {MessageStore} from "../../store/MessageStore";
    import {EnvStore} from "../../store/EnvStore";

    $: authStoreAuthStatus = AuthStore.authStatus;
    $: authStoreUser = AuthStore.user;


    let lastCheckAuthDate = null;

    onMount(() => {

        // const authStoreAuthStatusWritable = AuthStore.authStatusWritable;
        // console.log('authStatus', $authStoreAuthStatus);

        if ($authStoreAuthStatus === AuthStore.AuthStatusType.undefined) {
            // ログインAPI呼び出し
            loadData();
        }


    });


    function loadData() {
        const params = {};
        const url = UrlUtil.createApiUrl("auth/state", params);

        const fullScreenMessageData = new MessageStore.FullScreenMessageData();
        fullScreenMessageData.message = "ログイン状態を確認しています...";
        fullScreenMessageData.description = "";
        MessageStore.fullScreenMessage.set(fullScreenMessageData);
        HttpRequestUtil.getRequest(url, (response) => {
            console.log(response);
            const body = response['body'];
            const user = body['user'];
            AuthStore.login(user);

            const appEnv = body['app_env'];
            EnvStore.type.set(appEnv);

            MessageStore.fullScreenMessage.set(null);
        });

        lastCheckAuthDate = new Date();
    }

    // 再度認証状態をチェックする時間(8時間)
    const reCheckAuthTimeOnFocusWindow = 1000 * 60 * 60 * 8;

    // const reCheckAuthTimeOnFocusWindow = 1000;

    function onFocusWindow() {
        if (lastCheckAuthDate != null) {
            const currentDate = new Date();
            const diffTime = currentDate.getTime() - lastCheckAuthDate.getTime();
            if (diffTime < reCheckAuthTimeOnFocusWindow) {
                return;
            }
        }

        loadData();
    }

    function onBlurWindow() {
        // console.log('onBlur');
    }


</script>

<svelte:window on:focus={onFocusWindow} on:blur={onBlurWindow}/>

<div class="auth-state-view">
    {#if $authStoreUser != null}
        <div class="authorized-user-information">
            <div class="company-department">
                <div class="company-name">
                    { $authStoreUser['company_name'] }
                </div>
                {#if $authStoreUser['department_name'] != null}
                    <div class="department-name">
                        { $authStoreUser['department_name'] }
                    </div>
                {/if}
            </div>
            <div class="name">
                { $authStoreUser['name'] }
            </div>
        </div>
    {/if}


</div>
<style lang="scss">
    .auth-state-view {
        .authorized-user-information {
            display: flex;
            align-items: center;
            gap: 12px;

            .company-department {
                display: flex;
                flex-direction: column;
                gap: 4px;

                .company-name {
                    font-size: 0.5em;
                    line-height: 1em;
                    opacity: 0.8;
                }

                .department-name {
                    font-size: 0.8em;
                    line-height: 1em;
                }
            }

        }

    }
</style>